const useGroups = () => {
  const groups = localStorage.getItem('groups');

  return groups;
};

export default useGroups;
